module.exports = __webpack_public_path__ + "Flag-86.5191998278a66dbf7eaaf09fcf90af16.svg";